import resetState from './default';

const setID = (state, value) => state.id = value;
const setScenario = (state, value) => state.scenario = value;
const setEnergies = (state, value) => state.energies = value;
const setAddress = (state, value) => state.address = value;
const setAddressStreet = (state, value) => state.address.street = value;
const setAddressNumber = (state, value) => state.address.number = value;
const setAddressBox = (state, value) => state.address.box = value;
const setAddressFloor = (state, value) => state.address.floor = value;
const setAddressLocality = (state, value) => state.address.locality = value;
const setInhabitants = (state, value) => state.inhabitants = value;
const setUnoccupied = (state, value) => state.unoccupied = value;
const setUnoccupiedType = (state, value) => state.unoccupiedType = value;
const setSocialRate = (state, value) => state.socialRate = value;
const setRemark = (state, value) => state.remark = value;
const setDeliveryDate = (state, value) => state.deliveryDate = value;
const setInstalmentDaysDD = (state, value) => state.instalmentDaysDD = value;
const setInstalmentDaysBT = (state, value) => state.instalmentDaysBT = value;
const setElectricity = (state, value) => state.electricity = value;
const setElectricityEanKnown = (state, value) => state.electricity.eanKnown = value;
const setElectricityEan = (state, value) => state.electricity.ean = value;
const setElectricityContractType = (state, value) => state.electricity.contractType = value;
const setElectricityGreen = (state, value) => state.electricity.green = value;
const setElectricityDuration = (state, value) => state.electricity.duration = value;
const setElectricityPreviousProvider = (state, value) => state.electricity.previousProvider = value;
const setElectricityAsap = (state, value) => state.electricity.asap = value;
const setElectricityDeliveryDate = (state, value) => state.electricity.deliveryDate = value;
const setElectricityMoveDate = (state, value) => state.electricity.moveDate = value;
const setElectricityOpenMeterDate = (state, value) => state.electricity.openMeterDate = value;
const setElectricitySolarPanel = (state, value) => state.electricity.solarPanel = value;
const setElectricitySolarPanelScenario = (state, value) => state.electricity.solarPanelScenario = value;
const setElectricitySolarPanelPower = (state, value) => state.electricity.solarPanelPower = value;
const setElectricitySolarPanelNumber = (state, value) => state.electricity.solarPanelNumber = value;
const setElectricitySolarPanelCertification = (state, value) => state.electricity.solarPanelCertification = value;
const setElectricityMeter = (state, value) => state.electricity.meter = value;
const setElectricityMeterType = (state, value) => state.electricity.meter.type = value;
const setElectricityMeterInjection = (state, value) => state.electricity.meter.injection = value;
const setElectricityMeterNumber = (state, value) => state.electricity.meter.number = value;
const setElectricityMeterStatus = (state, value) => state.electricity.meter.status = value;
const setElectricityMeterReadingType = (state, value) => state.electricity.meter.readingType = value;
const setElectricityMeterPower = (state, value) => state.electricity.meter.power = value;
const setElectricityIndex = (state, value) => state.electricity.index = value;
const setElectricityIndexBase = (state, value) => state.electricity.index.base = value;
const setElectricityIndexHigh = (state, value) => state.electricity.index.high = value;
const setElectricityIndexLow = (state, value) => state.electricity.index.low = value;
const setElectricityIndexExclusiveNight = (state, value) => state.electricity.index.exclusiveNight = value;
const setElectricityIndexInjectionBase = (state, value) => state.electricity.index.injectionBase = value;
const setElectricityIndexInjectionHigh = (state, value) => state.electricity.index.injectionHigh = value;
const setElectricityIndexInjectionLow = (state, value) => state.electricity.index.injectionLow = value;
const setElectricityConsumptionBase = (state, value) => state.electricity.consumption.base = value;
const setElectricityConsumptionHigh = (state, value) => state.electricity.consumption.high = value;
const setElectricityConsumptionLow = (state, value) => state.electricity.consumption.low = value;
const setElectricityConsumptionExclusiveNight = (state, value) => state.electricity.consumption.exclusiveNight = value;
const setElectricityInjectionBase = (state, value) => state.electricity.consumption.injectionBase = value;
const setElectricityInjectionHigh = (state, value) => state.electricity.consumption.injectionHigh = value;
const setElectricityInjectionLow = (state, value) => state.electricity.consumption.injectionLow = value;
const setElectricityProduct = (state, value) => state.electricity.product = value;
const setElectricityRate = (state, value) => state.rates.electricity = value;
const setGas = (state, value) => state.gas = value;
const setGasEanKnown = (state, value) => state.gas.eanKnown = value;
const setGasEan = (state, value) => state.gas.ean = value;
const setGasContractType = (state, value) => state.gas.contractType = value;
const setGasGreen = (state, value) => state.gas.green = value;
const setWantOnlineGreen = (state, value) => state.wantOnlineGreen = value;
const setGasDuration = (state, value) => state.gas.duration = value;
const setGasPreviousProvider = (state, value) => state.gas.previousProvider = value;
const setGasAsap = (state, value) => state.gas.asap = value;
const setGasDeliveryDate = (state, value) => state.gas.deliveryDate = value;
const setGasMoveDate = (state, value) => state.gas.moveDate = value;
const setGasOpenMeterDate = (state, value) => state.gas.openMeterDate = value;
const setGasMeter = (state, value) => state.gas.meter = value;
const setGasMeterNumber = (state, value) => state.gas.meter.number = value;
const setGasMeterStatus = (state, value) => state.gas.meter.status = value;
const setGasMeterReadingType = (state, value) => state.gas.meter.readingType = value;
const setGasIndex = (state, value) => state.gas.index = value;
const setGasConsumption = (state, value) => state.gas.consumption = value;
const setGasProduct = (state, value) => state.gas.product = value;
const setGasRate = (state, value) => state.rates.gas = value;
const reset = (state) => Object.assign(state, resetState.getDefaultState());



export default {
    setID,
    setScenario,
    setEnergies,
    setAddress,
    setAddressStreet,
    setAddressNumber,
    setAddressBox,
    setAddressFloor,
    setAddressLocality,
    setInhabitants,
    setUnoccupied,
    setUnoccupiedType,
    setSocialRate,
    setRemark,
    setDeliveryDate,
    setInstalmentDaysDD,
    setInstalmentDaysBT,
    setElectricity,
    setElectricityEanKnown,
    setElectricityEan,
    setElectricityContractType,
    setElectricityGreen,
    setWantOnlineGreen,
    setElectricityDuration,
    setElectricityPreviousProvider,
    setElectricityAsap,
    setElectricityDeliveryDate,
    setElectricityMoveDate,
    setElectricityOpenMeterDate,
    setElectricitySolarPanel,
    setElectricitySolarPanelPower,
    setElectricitySolarPanelScenario,
    setElectricitySolarPanelNumber,
    setElectricitySolarPanelCertification,
    setElectricityMeter,
    setElectricityMeterType,
    setElectricityMeterInjection,
    setElectricityMeterNumber,
    setElectricityMeterStatus,
    setElectricityMeterReadingType,
    setElectricityMeterPower,
    setElectricityIndex,
    setElectricityIndexBase,
    setElectricityIndexHigh,
    setElectricityIndexLow,
    setElectricityIndexExclusiveNight,
    setElectricityIndexInjectionBase,
    setElectricityIndexInjectionHigh,
    setElectricityIndexInjectionLow,
    setElectricityConsumptionBase,
    setElectricityConsumptionHigh,
    setElectricityConsumptionLow,
    setElectricityConsumptionExclusiveNight,
    setElectricityInjectionBase,
    setElectricityInjectionHigh,
    setElectricityInjectionLow,
    setElectricityProduct,
    setElectricityRate,
    setGas,
    setGasEanKnown,
    setGasEan,
    setGasContractType,
    setGasGreen,
    setGasDuration,
    setGasPreviousProvider,
    setGasAsap,
    setGasDeliveryDate,
    setGasMoveDate,
    setGasOpenMeterDate,
    setGasMeter,
    setGasMeterNumber,
    setGasMeterStatus,
    setGasMeterReadingType,
    setGasIndex,
    setGasConsumption,
    setGasProduct,
    setGasRate,
    reset
};



// WEBPACK FOOTER //
// ./src/store/modules/contract/mutations.js